var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.287 1.029h.527V.287A.29.29 0 012.106 0h9.11a.29.29 0 01.292.287v.742h7.985c.583 0 1.077.386 1.234.912l.053-.075-.043.104 1.597 5.564v2.942c0 .33-.272.598-.607.598h-1.385c-.014-.962-.808-1.74-1.79-1.743-.985-.004-1.788.775-1.802 1.743H6.429v-.02c.004-.977-.797-1.772-1.79-1.776-.992-.004-1.8.785-1.803 1.763v.033H1.288C.58 11.074 0 10.504 0 9.806v-7.51C0 1.6.579 1.03 1.287 1.03z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.212 12.57a1.53 1.53 0 01-1.18-1.827 1.554 1.554 0 011.854-1.162 1.53 1.53 0 011.18 1.826 1.554 1.554 0 01-1.854 1.162z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.546 11.816a.747.747 0 01-.752-.741c0-.41.337-.741.752-.741.416 0 .753.331.753.74 0 .41-.337.742-.753.742zM4.303 12.57a1.53 1.53 0 01-1.19-1.82 1.554 1.554 0 011.849-1.17A1.53 1.53 0 016.15 11.4a1.554 1.554 0 01-1.848 1.17z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.632 11.816a.747.747 0 01-.752-.741c0-.41.337-.741.752-.741.416 0 .753.331.753.74 0 .41-.337.742-.753.742z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.068 3.17h2.963c.133 0 .242.106.242.239v1.866c0 .132-.108.239-.242.239H9.067a.241.241 0 01-.243-.24V3.41a.24.24 0 01.243-.24zM16.163 5.514h-2.962a.241.241 0 01-.243-.24V3.41c0-.132.108-.24.243-.24h2.962c.134 0 .243.107.243.24v1.865a.24.24 0 01-.243.24zM17.139 3.409c0-.132.108-.24.242-.24h2.113c.182 0 .35.09.453.23l-.003.008.108.235.41 1.367a.338.338 0 01-.3.504h-2.78a.241.241 0 01-.243-.24V3.41zM4.935 3.17h2.963c.134 0 .243.106.243.239v1.866c0 .132-.109.239-.243.239H4.935a.241.241 0 01-.243-.24V3.41c0-.133.11-.24.243-.24zM.797 3.17h2.962c.134 0 .243.106.243.239v1.866c0 .132-.11.239-.243.239H.797a.241.241 0 01-.243-.24V3.41c0-.133.109-.24.243-.24z",
    fill: "#161616"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.334 8.593h-.91a.29.29 0 01-.292-.287v-.377a.29.29 0 01.291-.287h.911v.951z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.93f7511c8380b656e6aa9286bda8683e.svg";
export { ForwardRef as ReactComponent };